<div class="swiper-container" #swiper>
    <div class="swiper-wrapper">
      <div *ngFor="let image of img" class="swiper-slide">
        <div
          class="slide-content"
          [style.height]="item.height"
          [style.width]="item.customField25"
          [ngStyle.lt-md]="{
            'height': item.heightMob,
            'width': item.customField26
          }"
        >
          <img  (click)="openlink(image.navigatedUrl)"
            [src]="bannerServerPath + image.img"
            alt="Slide Image"
            class="slide-img"
          />
        </div>
      </div>
    </div>
  </div>
  